import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import Container from '../atoms/Container';
import Sidebar from '../atoms/Sidebar';
import BiampLogo from '../atoms/BiampLogo';
import Title from '../atoms/Title';
import Subtitle from '../atoms/Subtitle';
import FooterWithLinks from '../sections/FooterWithLinks';

const SigninPage: React.FC = () => {
  const { loading, signin } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
  }, [loading]);

  const handleSignIn = () => {
    signin()
      .then(() => {
        window.location.replace('/selectorg');
      })
      .catch((error) => {
        console.error('Sign in failed', error);
      });
  };

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  return (
    <Container>
      <Sidebar>
        <BiampLogo />
        <Title sx={{ marginTop: 'auto' }}>Workplace Designer</Title>
        <Subtitle sx={{ marginTop: '40px' }}>
          We’ll guide you to easily design your space, position furniture, and receive a customized layout plan for Biamp solutions
        </Subtitle>
        <SignInButton sx={{ marginTop: '40px', marginBottom: 'auto' }} onClick={handleSignIn}>Sign in or Register</SignInButton>
        <FooterWithLinks />
      </Sidebar>
    </Container>
  );
};

// Styled components using MUI styled API
const SignInButton = styled(Button)({
  height: '44px',
  width: '100%',
  paddingLeft: '16px',
  paddingRight: '16px',
  background: 'white',
  borderRadius: '6px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  display: 'inline-flex',
  color: '#222222',
  fontSize: '14px',
  fontFamily: 'Open Sans !important',
  fontWeight: 700,
  textTransform: 'none',
});

const LoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
});

export default SigninPage;
